/**
 * Dispatches GetNotifications action
 * @dispatch {@link getNotifications}
 * @param ctx
 * @see libs/app/client/shared/components/notifications/data-access/src/lib/state/notifications.state.ts
 */
export class CheckCount {
  public static readonly type = '[Notifications] CheckCount';
}
